<div mat-dialog-title>
  <app-dialog-close-cross />
  <h2 class="dialog-title">{{ 'DCP_RELEASE.TITLE' | translate }}</h2>
</div>
<app-release-note [releases]="releases" />
<div mat-dialog-actions>
  <button class="space-h-s btn-warn" mat-raised-button (click)="close()">{{ 'CLOSE' | translate }}</button>
</div>
